import { helper } from '@ember/component/helper';

export const isNegative = (params) => {
  return params < 0;
};

export default helper(isNegative);
